import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import EyeSlash from "../../Assets/Image/admin/slasheye.png";
import Eye from "../../Assets/Image/admin/eye.png";
import logo from "../../Assets/Image/admin/logo.png";
import { Circles } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import welo from "../../Assets/Image/sidebar/e-logo.png";
import toast from "react-hot-toast";
import axios from "axios";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import { ADMIN_LOGIN_API } from "../../Services/Api";
import getDeviceToken from "../../Base-Component/getDeviceToken/getDeviceToken";

function Login() {
  const navigate = useNavigate();
  const [eyes, setEyes] = useState(0);
  const [texts, setTexts] = useState("password");
  const [isLoading, setIsLoading] = useState(false);
  const [fcmToken, setFcmToken] = useState("abcd");

  let deviceId = localStorage.getItem("DeviceId");

  useEffect(() => {
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem("DeviceId", deviceId);
    }
  }, [deviceId]);

  useEffect(() => {
    const fetchToken = async () => {
      const token = await getDeviceToken();
      if (token) {
        setFcmToken(token);
      }
    };
    fetchToken();
  }, []);

  const handleEyes = () => {
    const flag = eyes === 0 ? 1 : 0;
    setEyes(flag);

    const text = texts === "password" ? "text" : "password";
    setTexts(text);
  };

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .matches(/^([a-zA-Z0-9._%+-]+)@/, "Invalid email address")
      .required("Required"),
    password: Yup.string()
      .min(8, "Minimum 8 characters required")
      .required("Required"),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    setIsLoading(true);
    axios
      .post(
        ADMIN_LOGIN_API,
        {
          email: values.email,
          password: values.password,
          device_type: "web",
          device_id: deviceId,
          device_token: fcmToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.status === 1) {
          toast.success(res.data.message);

          const user = res.data.isUser;
          const role = res.data.role;
          const usertoken = res.data.usertoken;
          const obj = {
            userId: user.id,
            role,
          };
          localStorage.setItem("e-learn-data", JSON.stringify(obj));
          Cookies.set("e_learning_token", usertoken);
          navigate("/dashboard");
        } else {
          toast.error(res.data.message);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setIsLoading(false);
      });
  };

  return (
    <div className="grid grid-cols-12 gap-x-6 fontNew">
      <div className="lg:col-span-5 h-[100vh] w-full 2xl:flex xl:flex lg:flex hidden bg-[#484D52]">
        <div className="w-full flex flex-col justify-center items-center">
          <img src={logo} className="w-56" alt="" />
        </div>
      </div>
      <div className="lg:col-span-7 col-span-12 mx-3">
        <div className="text-start flex justify-center items-center h-[100vh]">
          <div>
            <div className="lg:hidden flex justify-center mb-10">
              <img src={welo} className="w-[180px] h-[40px]" alt="" />
            </div>
            <h4 className="fontNew sm:text-3xl text-xl font-semibold pb-3">
              Glad to see you!
            </h4>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div>
                    <div className="flex items-center mt-3">
                      <p className="fontNew text-sm font-medium">Email</p>
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red-500 text-sm ms-2"
                      />
                    </div>
                    <div className="mt-3 mb-6">
                      <div className="md:w-[380px] w-full flex my-3 items-center">
                        <Field
                          type="email"
                          name="email"
                          autoComplete="off"
                          className="bg-transparent px-4 rounded-xl border-2 border-slate-300 w-full outline-[#e1c595] h-[54px] text-base"
                          placeholder="Email"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center mt-2">
                      <p className="text-sm font-medium">Password</p>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-red-500 text-sm ms-2"
                      />
                    </div>
                    <div className="mt-3 mb-6">
                      <div className="flex my-3 items-center">
                        <Field
                          type={texts}
                          name="password"
                          autoComplete="off"
                          className="bg-transparent ps-4 pe-12 rounded-xl border-2 border-slate-300 w-full outline-[#e1c595] h-[54px] text-base"
                          placeholder="Password"
                        />
                        {eyes === 0 ? (
                          <img
                            src={EyeSlash}
                            onClick={handleEyes}
                            className="p-2 w-10 h-10 -ms-12 cursor-pointer"
                            alt=""
                          />
                        ) : (
                          <img
                            src={Eye}
                            onClick={handleEyes}
                            className="p-2 w-10 h-8 -ms-12 cursor-pointer"
                            alt=""
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mt-14">
                    <button
                      type="submit"
                      className="fontNew h-[54px] items-center w-full rounded-2xl flex font-base justify-center text-white text-base bg-[#e29c29]"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <Circles
                          width={23}
                          height={23}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      ) : (
                        "Login"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
